<template>
  <div style="padding: 8px">
    <Account class="q-pa-md "/>
    <!--<SATProfileDetails class="q-px-md"/>-->
    <div class="q-pa-md">

        <q-list>
          <q-item style="padding: 0px" >
          <!-- <q-item v-bind:key="Holding.index" v-for="Holding in StoreStateCD.Holdings" style="padding: 0px"> -->
              <!-- <q-item-section style="border-bottom:1px solid #063ca1"> -->
              <q-item-section class="" style="border-radius: 0.5rem; border: 1px solid #e0e0e0; background: #fff; margin-bottom: 0px; box-shadow: none; background: #fff;">
                  <div class="">
                    <div class="text-bold q-pa-md" style="font-size: 16px;">{{ $t("Switch.title") }} </div>
                    <q-separator style="margin: 0 0.75rem; width: auto;" />
                  </div>

                  <q-item v-if="StoreStateCD.Holdings.length < 1">
                      <q-item-section>
                        {{$t("Switch.nocontent")}}
                      </q-item-section>
                  </q-item>

                  <div class="row">

                  <div class="q-px-md q-pt-md col-xs-12 col-md-12" style="" v-bind:key="Holding.index" v-for="Holding in StoreStateCD.Holdings">
                    <!-- StoreStateCD.Holdings or dummyData -->
                    <q-item-section class="q-pa-none" style="">
                      <div class="row q-mb-sm">
                          <div class="col-12 q-pl-sm q-mb-md schemeName">
                              <!-- switch fund name header at left -->
                              <!-- <q-input :label='$t("Switch.fund")' :value="Holding.ProductName" readonly borderless /> -->
                            <div class="text-bold" style="font-size: 15px;">{{ Holding.ProductName }}</div>
                          </div>

                          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm">
                            <div class="fieldStyle">
                            <b>{{$t("Switch.totalamount")}}</b>
                            <div>{{ Holding.Amount }}</div>
                            </div>
                              <!-- switch amount at right -->
                              <!-- <q-input
                                  :label='$t("Switch.totalamount")'
                                  input-class="text-right"
                                  class="q-field__native text-left" 
                                  v-model="Holding.Amount" 
                                  v-money="money"
                                  readonly
                                  borderless
                                /> -->
                          </div>
                        
                          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm">
                             <div class="fieldStyle">
                              <b>{{$t("Redeem.plan")}}</b>
                              <div>{{Holding.Plan}}</div>
                              </div>
                          </div>
                          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm">
                             <div class="fieldStyle">
                            <b>{{$t("Redeem.currency")}}</b>
                            <div>{{Holding.Currency}}</div>
                            </div>
                          </div>
                          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" >
                             <div class="fieldStyle">
                              <b>{{$t("Redeem.currentnav")}}</b>
                              <div>{{Holding.NAV}}</div>
                              </div>
                          </div>
                          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" >
                             <div class="fieldStyle">
                              <b>{{$t("Redeem.pendingRedemption")}}</b>
                              <div>{{formatthousandseparator(Holding.pendingRedemptionUnit)}}</div>
                              </div>
                          </div>
                          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" >
                             <div class="fieldStyle">
                              <b>{{$t("Redeem.balanceunit")}}</b>
                              <div>{{formatthousandseparator(Holding.BalanceUnit)}}</div>
                              </div>
                          </div>
                        
                      </div>

                      <!-- click to switch btn -->
                      <div class="row text-center q-mb-md q-pr-sm" style="margin-top: auto;">
                        <div class="col-xs-12">
                          <FT
                            :FundName=Holding.ProductName
                            :Plan=Holding.Plan
                            :FundCurrency=Holding.Currency
                            :BalanceUnit=Holding.BalanceUnit
                            :BalanceUnitA=Holding.BalanceUnitA
                            :BalanceUnitB=Holding.BalanceUnitB
                            :Amount=Holding.Amount
                            :ProductType=Holding.ProductType
                            :AccountType=StoreStateCD.Account.AccountType
                            :SchemeName=Holding.ProductName
                            :Scheme=Holding.Scheme
                          />
                        </div>
                      </div>

                    </q-item-section>


                    <!-- start switching "table" -->
                    <!-- <div class="row text-center q-px-sm">
                        <div class="col-xs-12 col-sm-2 col-md-2 q-pa-sm" style="border:1px solid #A6A6A6">
                          <a class="text-grey-6">{{$t("Redeem.plan")}}</a><br>
                          <a class="">{{Holding.Plan}}</a>
                        </div>
                        <div class="col-xs-12 col-sm-2 col-md-2 q-pa-sm" style="border:1px solid #A6A6A6">
                          <a class="text-grey-6">{{$t("Redeem.currency")}}</a><br>
                          <a class="text-center">{{Holding.Currency}}</a>
                        </div>
                        <div class="col-xs-12 col-sm-2 col-md-2 q-pa-sm" style="border:1px solid #A6A6A6">
                          <a class="text-grey-6">{{$t("Redeem.currentnav")}}</a><br>
                          <a class="text-center">{{Holding.NAV}}</a>
                        </div> -->
                        <!--  <div class="col" style="border:1px solid #A6A6A6">
                          <a class="text-grey-6">{{$t("Redeem.unitholding")}}</a><br>
                          <a class="text-center " >{{Holding.Amount.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})|thousandSeparator}}</a>
                        </div> -->
                      <!-- <div class="col-xs-12 col-sm-3 col-md-3 q-pa-sm" style="border:1px solid #A6A6A6">
                          <a class="text-grey-6">{{$t("Redeem.pendingRedemption")}}</a><br>
                          <a class="text-center">{{ formatthousandseparator(Holding.pendingRedemptionUnit)}}</a>
                        </div> -->
                        <!-- <div class="col" style="border:1px solid #A6A6A6">
                          <a class="text-grey-6">Pending Investment/ Switch In</a><br>
                          <a class="text-center">{{ formatthousandseparator(Holding.pendingInvestmentUnit)}}</a>
                        </div> -->
                        <!-- <div class="col-xs-12 col-sm-3 col-md-3 q-pa-sm" style="border:1px solid #A6A6A6">
                          <a class="text-grey-6">{{$t("Redeem.balanceunit")}}</a><br>
                          <a class="text-center">{{ formatthousandseparator(Holding.BalanceUnit)}}</a>
                        </div>
                      </div> -->
                      <!-- end switching "table" -->

                      
                  <!-- </q-item-label> -->
                  <!-- StoreStateCD.Holdings or dummyData -->
                  <q-separator style="margin: 0 0.75rem; width: auto;" v-if="StoreStateCD.Holdings.indexOf(Holding) + 1 != StoreStateCD.Holdings.length"/>

                  </div>
                  
                  </div>
              </q-item-section>
          </q-item>

          <!-- no content -->
          <!-- <q-item v-if="StoreStateCD.Holdings.length < 1">
              <q-item-section>
                {{$t("Switch.nocontent")}}
              </q-item-section>
          </q-item> -->
        </q-list>

        <div v-if="StoreStateCD.NonEPFHoldings.length > 0" class="q-pa-sm q-mt-md" style="border-radius: 0.5rem; border: 1px solid #e0e0e0; background: #fff;">
          <q-toggle 
            
            v-model="StoreStateT.showOtherEPFScheme"
            @input="TriggerEmisArray($event)" 
            
            color="green-14" 
            :label='$t("common.showotherepf")' 
            right-label  
     
          />
        </div>

        </div>
      
        <!-- 
          <q-toggle 
            v-if="StoreStateCD.NonEPFHoldings.length > 0"
            v-model="StoreStateT.showOtherEPFScheme"
            @input="TriggerEmisArray($event)" 
            checked-icon="check" 
            color="green-14" 
            :label='$t("common.showotherepf")' 
            right-label  
            unchecked-icon="clear"  
          /> 
        -->
    <!-- <div class="q-pa-md">
      <q-list bordered separator>
      <q-item class="bg-accent text-primary">
          <q-item-section>
            <q-item-label class="caption">HOLDINGS</q-item-label>
          </q-item-section> -->
          <!-- <q-item-section side>
            <q-btn color="primary" style="width:100%" label="Buy New Fund" @click="BuyNewFund()" no-caps/>
          </q-item-section> -->
      <!-- </q-item>
      <q-item v-if="StoreStateCD.Holdings.length==0" >
        <q-item-section>
            No Content
        </q-item-section>
      </q-item>
      <q-expansion-item
        class="overflow-hidden"
        dense-toggle
        header-class="bg-white text-dark"
        expand-icon-class="text-primary" 
        v-bind:key="Holding.index"
        v-for="Holding in StoreStateCD.Holdings"
      >
        <template v-slot:header>
          <q-item-section avatar>
            <q-badge color="primary" text-color="white">{{ Holding.Plan }}</q-badge>
          </q-item-section>

          <q-item-section>
            <q-item-label class="text-subtitle2">{{ Holding.ProductName }}</q-item-label>
            <q-item-label class="text-caption">MYR{{ formatPrice(Holding.Amount) }}</q-item-label>
          </q-item-section>
        </template>
        <q-item class="bg-white text-black shadow-2">
          <q-item-section>
            <FIInfo v-if="StoreStateCD.Account.AccountType==='UTF'"
              LabelTopLeft="Plan"
              :ValueTopLeft=Holding.Plan
              LabelTopRight="Currency"
              :ValueTopRight=Holding.Currency
              LabelBottomLeft="Current Price"
              :ValueBottomLeft=Holding.NAV
              LabelBottomRight="Unit Holdings"
              :ValueBottomRight=Holding.BalanceUnit
            />
            <FIInfo v-else-if="StoreStateCD.Account.AccountType==='PRS'"
              LabelTopLeft="CurrentPrice"
              :ValueTopLeft=Holding.NAV
              LabelTopRight="Currency"
              :ValueTopRight=Holding.Currency
              LabelBottomLeft="Account A Unit Balance"
              :ValueBottomLeft=Holding.BalanceUnitA
              LabelBottomRight="Account B Unit Balance"
              :ValueBottomRight=Holding.BalanceUnitB
            />
            <br>
            <FT
              :FundName=Holding.ProductName
              :Plan=Holding.Plan
              :FundCurrency=Holding.Currency
              :BalanceUnit=Holding.BalanceUnit
              :BalanceUnitA=Holding.BalanceUnitA
              :BalanceUnitB=Holding.BalanceUnitB
              :Amount=Holding.Amount
              :ProductType=Holding.ProductType
              :AccountType=StoreStateCD.Account.AccountType
              :SchemeName=Holding.ProductName
              :Scheme=Holding.Scheme
            />
          </q-item-section>
        </q-item>
      </q-expansion-item>
      </q-list>
    </div> -->

    <!-- Switching "My Cart" section -->
    <!-- title outside -->
    <!-- <div class="text-h6 q-pa-md col-xs-12 col-sm-12 col-md-12">{{ $t("Switch.mycart") }}</div> -->
    <div class="row q-pa-md">
      <q-card bordered class="page " style="width:100%; border-radius: 0.5rem; border: 1px solid #e0e0e0; background: #fff; margin-bottom: 20px; box-shadow: none;">
        <!-- <q-card-section>
        <q-chip class="col-xs-12 col-sm-2 col-md-2" size="lg" color="primary"  text-color="white" icon="shopping_cart">
          {{$t("Switch.mycart")}}
        </q-chip>
        </q-card-section> -->
          <div class="">
            <div class="text-bold q-pa-md" style="font-size: 16px;">{{ $t("Switch.mycart") }} </div>
            <q-separator style="margin: 0 0.75rem; width: auto;" />
          </div>

              <!-- <b>{{ $t("Switch.mycart") }} </b> -->
              <!-- <q-separator /> -->

        <q-card-section style="padding: 0px !important;" class="scroll">
          <ShoppingCart/>
        </q-card-section>

        <!-- <q-separator/> -->

        <!-- TODO: check cart in store or not, then hide check out button -->
        <!-- <q-card-actions align="right" class="q-ma-sm">
        
          <q-btn :label='$t("common.continueBtn")' @click="ConfirmedCart();scrollPositionToTop();" unelevated style="background-color: #ff6666; color: white"/>
        </q-card-actions> -->
      </q-card>
      <div class="text-right" style="width: 100%">
        <q-btn :label='$t("common.continueBtn")' @click="ConfirmedCart();scrollPositionToTop();" unelevated style="background-color: #ff6666; color: white"/>
      </div>
    </div>

    <!--Popup Cart Page Modal-->
    <q-dialog full-width persistent v-model="CartModal" transition-show="rotate" transition-hide="rotate">
      <q-card>
        <q-card-section>
          <div class="text-h6">MY CART</div>
        </q-card-section>

        <q-card-section style="max-height: 70vh" class="scroll">
          <ShoppingCart/>
        </q-card-section>

        <q-separator/>

        <q-card-actions align="right" class="q-mx-sm">
          <q-btn label="Cancel" v-close-popup />
          <q-btn label="Check Out" color="primary" text-color="white" @click="ConfirmedCart()" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <!--Popup Basis Recommendation Modal-->
    <q-dialog full-width persistent v-model="BasisRecommendationModal" transition-show="scale" transition-hide="jump-up">
      <q-card>
        <q-form @submit="DoneBasisRecommendation()">
          <q-card-section>
            <div class="text-subtitle">Please complete below field.</div>
          </q-card-section>

          <q-separator/>

          <q-card-section style="max-height: 70vh" class="scroll">
            <BasisRecommendation/>
          </q-card-section>

          <q-separator/>

          <q-card-actions align="right" class="q-mx-sm">
            <q-btn label="Done" color="primary" text-color="white" type="submit" />
          </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>
  </div>
</template>

<style>
@media screen and (min-width: 600px) {
  .fieldStyle{
    border: 1px solid #e0e0e0; border-radius: 0.5rem; padding: 8px 12px; height: 100%;
  }
}

</style>

<script>
import store from '../store';
import { mapState, mapActions, mapGetters } from "vuex";
import {VMoney, Money} from 'v-money'
//import CD from "@/components/ClientDetails";
import FT from "./FundTransactionSwitch";
//import FIInfo from './FundInvestmentInfo'
//import FTNF from "./FundTransactionNewFund";
import Account from '@/components/AccountDetails_2'
import ShoppingCart from '@/components/ShoppingCartSwitch.vue'
//import SATProfileDetails from '@/components/SATProfileDetails.vue'
//import BasisRecommendation from '@/components/BasisRecommendation.vue'
import { date, uid } from 'quasar';
export default {
  components: {
    FT,
   // FTNF,
    //FIInfo,
    ShoppingCart,
    ////BasisRecommendation,
   // SATProfileDetails,
    Account
  },
  data() {
    return {
      BuyNewFundModal: false,
      CartModal : false,
      StoreStateCD: store.state.CD,
      StoreStateAOD : store.state.AOD,
      StoreStateT : store.state.Transactions,   
      TransactionId : '',
      BasisRecommendationModal : false,
      tempMobileNo:'',
      StoreStateAD : store.state.AD, 
      StoreStateLogin: store.state.Login,
      money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false /* doesn't work with directive */
      },
       dummyData: [ { "CustomerId": "670529013823", "AccountID": "920000000413", "Scheme": "SOF", "ProductName": "SELECT OPPORTUNITY FUND", "Plan": "EPF", "FloatingUnit": "0.00", "pendingRedemptionUnit": "1100.00", "pendingInvestmentUnit": "1100.00", "BalanceUnit": "2097.27", "Amount": "2934.45", "NAV": "0.9178", "NAVDate": "2020-10-10", "Channel": "AHAM", "Currency": "MYR" },
      { "CustomerId": "670529013823", "AccountID": "920000000413", "Scheme": "SOF", "ProductName": "SELECT OPPORTUNITY FUND", "Plan": "EPF", "FloatingUnit": "0.00", "pendingRedemptionUnit": "1100.00", "pendingInvestmentUnit": "1100.00", "BalanceUnit": "2097.27", "Amount": "2934.45", "NAV": "0.9178", "NAVDate": "2020-10-10", "Channel": "AHAM", "Currency": "MYR" } ]
    };
  },
   directives: {money: VMoney},
  mounted() {
  /* this.$q.loading.show({
            spinnerSize : 50
        }),
    this.GetListOfFund();
    this.GetCif({
      ApplicationId : '910328106187'
    }).then(res=>{
                    this.$q.loading.hide()
                })*/
   
   /*this.GetAccountHoldings({
        AccountId: this.StoreStateCD.Account.AccountId
      })*/
    
  },
  computed: {
    ...mapGetters([  
          "cartCount" 
             ]),
  },
  methods: {
    ...mapActions([
        "PostTransaction",
        "GetListOfFund",
        "FilterFundPlanByProductType",
        "PostSATDetails",
        "GetAccountHoldings",
        "GetCif",
        "RequestTAC",
         "TransactRedeemProcess",
         "PostTransaction_Submit",
        "eMISTransactionConfirmSwitchRedeem",
        "getTransaction",
        "GetApplicationAvailableUnitCheck"
    ]),
    OpenCartModal(){
      this.CartModal = true;
    },
    TriggerEmisArray(event){

      this.$store.dispatch('Logging',
        {
            typeid :'5', 
            appid : '2',
            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'TriggerEmisArray(Switch), showOtherEPFScheme-> ' + this.StoreStateT.showOtherEPFScheme
        });
      if(this.StoreStateT.showOtherEPFScheme == true){
        this.$store.dispatch('Logging',
        {
            typeid :'5', 
            appid : '2',
            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'TriggerEmisArray(Switch), -> showOtherEPFScheme-> ' + this.StoreStateT.showOtherEPFScheme 
        });
        for(var i=0; i< this.StoreStateCD.NonEPFHoldings.length; i++){
          this.StoreStateCD.Holdings.push({
            CustomerId: this.StoreStateCD.NonEPFHoldings[i].CustomerId,
            AccountID: this.StoreStateCD.NonEPFHoldings[i].AccountID,
            Scheme: this.StoreStateCD.NonEPFHoldings[i].Scheme,
            ProductName: this.StoreStateCD.NonEPFHoldings[i].ProductName,
            Plan: this.StoreStateCD.NonEPFHoldings[i].Plan,
            pendingRedemptionUnit : parseFloat(this.StoreStateCD.NonEPFHoldings[i].pendingRedemptionUnit).toFixed(2),
            pendingInvestmentUnit: parseFloat(this.StoreStateCD.NonEPFHoldings[i].pendingRedemptionUnit).toFixed(2),
            FloatingUnit : parseFloat(this.StoreStateCD.NonEPFHoldings[i].FloatingUnit).toFixed(2),
            BalanceUnit: parseFloat(this.StoreStateCD.NonEPFHoldings[i].BalanceUnit).toFixed(2),
            Amount: parseFloat(this.StoreStateCD.NonEPFHoldings[i].Amount).toFixed(2),
            BalanceUnitA: this.StoreStateCD.NonEPFHoldings[i].BalanceUnitA,
            BalanceUnitB: this.StoreStateCD.NonEPFHoldings[i].BalanceUnitB,
            BalanceAmountA: this.StoreStateCD.NonEPFHoldings[i].BalanceAmountA,
            BalanceAmountB: this.StoreStateCD.NonEPFHoldings[i].BalanceAmountB,
            NAV: this.StoreStateCD.NonEPFHoldings[i].NAV,
            NAVDate: this.StoreStateCD.NonEPFHoldings[i].NAVDate,
            Channel : this.StoreStateCD.NonEPFHoldings[i].Channel,
            AgentID: this.StoreStateCD.NonEPFHoldings[i].AgentID,
            Currency: this.StoreStateCD.NonEPFHoldings[i].Currency
          })
        }

      }
      if(this.StoreStateT.showOtherEPFScheme === false){

         this.$store.dispatch('Logging',
            {
                typeid :'5', 
                appid : '2',
                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'TriggerEmisArray(Switch), -> showOtherEPFScheme-> ' + this.StoreStateT.showOtherEPFScheme + ' before this.StoreStateCD.Holdings.length ->' +  this.StoreStateCD.Holdings.length
            });

         for(var i=0; i< this.StoreStateCD.Holdings.length; i++){
         // console.log(i)
          if(this.StoreStateCD.Holdings[i].Channel==='AHAM'){ 
         //   console.log(i + " --> " + this.StoreStateCD.Holdings[i].Channel)              
              this.StoreStateCD.Holdings.splice(i,this.StoreStateCD.Holdings.length)
            // break;
          }
        } 

        this.$store.dispatch('Logging',
          {
              typeid :'5', 
              appid : '2',
              str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' TriggerEmisArray(Switch), -> showOtherEPFScheme-> ' + this.StoreStateT.showOtherEPFScheme + ' after this.StoreStateCD.Holdings.length ->' +  this.StoreStateCD.Holdings.length
          });


          if(this.StoreStateCD.Transaction.Switching.length>0){
          this.$q.loading.show({
              spinnerSize: 50
          })

        /* for(var j=0; j<this.StoreStateCD.Transaction.Redemption.length; j++){
          if(this.StoreStateCD.Transaction.Redemption[j].count === count ){
            this.StoreStateCD.Transaction.Redemption.splice(j,1)
          }
        }   */      

          this.StoreStateCD.Transaction.Switching = []

          
          
          this.GetAccountHoldings()
          .then(res => {
              this.$store.dispatch('Logging',{
                  appid : '2',
                  typeid :'4', 
                  str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' GetAccountHoldings (Switch) reset, ID Type -> . res - > '+  res
              });

              if (res == true) {
                this.PostTransaction({
                  ApplicationId : this.StoreStateCD.FormDetails.ApplicationId
                })
                  .then(res=>{

                    this.$store.dispatch('Logging',
                    {
                        typeid :'4', 
                        appid : '2',
                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' RESET DRAFT CART (Switch)-> ' + this.StoreStateCD.FormDetails.ApplicationId + '. res --> ' + res
                    });
                    if(res!=true){
                        this.$q.loading.hide()
                        this.$q.dialog({
                            title: 'Error',
                            message:  res ,
                        })    
                    }
                    else{
                      this.$q.loading.hide()
                    }
                  })  
              } else if(res === -1){
                this.$store.dispatch('Logging',{
                    appid : '2',
                    typeid :'4', 
                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetAccountHoldings reset (Switch), error ' //+ res
                });

                  this.$q.dialog({
                    title: 'Error',
                    message : 'Investor Holding details API is not responding'
                })
                    this.$q.loading.hide()
              }else{
                    this.$store.dispatch('Logging',{
                        appid : '2',
                        typeid :'4', 
                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetAccountHoldings reset (Switch), error ' //+ res
                    });
                    this.$q.dialog({
                        title: 'Error',
                        message : res
                    })
                  this.$q.loading.hide()
                }
          })

        }  
      }
      /* else{

          this.$store.dispatch('Logging',
            {
                typeid :'5', 
                appid : '2',
                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'TriggerEmisArray(Switch), -> showOtherEPFScheme-> ' + this.StoreStateT.showOtherEPFScheme + ' before this.StoreStateCD.Holdings.length ->' +  this.StoreStateCD.Holdings.length
            });
          for(var i=0; i< this.StoreStateCD.Holdings.length; i++){
            // console.log(i)
           // console.log(this.StoreStateCD.Holdings[i].ProductName + " -- "+ this.StoreStateCD.Holdings[i].Channel)
            if(this.StoreStateCD.Holdings[i].Channel=='AHAM'){
              this.StoreStateCD.Holdings.splice(i,1)
             // break;
            }
          }
      } */     
    },
     formatthousandseparator(value) {
      // alert(value)
       if(value != undefined){

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
       }
      //let val = (value / 1).toFixed(2).replace(",", ".");
    },
    ConfirmedCart(){
      if((this.StoreStateCD.Transaction.Investment.length > 0)||(this.StoreStateCD.Transaction.Redemption.length > 0)||(this.StoreStateCD.Transaction.Switching.length > 0)){
         this.$q.loading.show({
              spinnerSize: 50
            }),


        this.$store.dispatch('Logging',
        {
            typeid :'5', 
            appid : '2',
            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' ConfirmedCart(Switch), -> Switching Size-> ' + this.StoreStateCD.Transaction.Switching.length
        });

        this.CartModal = false
      var vm = this;
       /*  this.PostTransaction_Submit().then(res=>{
          
          if(res===true){  */ 
            this.getTransaction().then(res=>{
                  if(res === true){
                    if(this.StoreStateT.Switching.length > 0){

                      var minSwitch = 0;
                      var accBal=0;
                      var availableUnit = 0;
                      var switchUnit = 0;
                      var checking = true;
                      var msg= '';
                      var SchemeName = '';

                      for(var i=0; i<this.StoreStateT.Switching.length; i++ ){
                        minSwitch = this.StoreStateT.Switching[i].MinimumSwitchUnits,
                        accBal = this.StoreStateT.Switching[i].MinimumAccountBalance,
                        availableUnit = this.StoreStateT.Switching[i].AvailableUnits 
                        //- this.StoreStateT.Switching[i].Units
                        switchUnit = this.StoreStateT.Switching[i].Units
                        SchemeName = this.StoreStateT.Switching[i].SchemeName
                        
                      //  console.log("availableUnit ->" + availableUnit )
                       // console.log(switchUnit +' < '+ minSwitch +"-->" + SchemeName )
                        this.$store.dispatch('Logging',
                        {
                            typeid :'5', 
                            appid : '2',
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirmSwitchRedeem(Switch) cart detail, -> availableUnit ->'+ availableUnit +' switchUnit -> ' + switchUnit +' < minSwitch :'+ minSwitch +"-->" + SchemeName
                        });
                        
                        if(availableUnit >= minSwitch){
                          if(switchUnit < minSwitch){
                            checking = false
                            msg = 'Minimum Switching Units for ' + SchemeName + ' is :' + minSwitch + " Units"
                            
                            this.$q.loading.hide()
                            this.$q.dialog({
                              title : 'Error',
                              message :  msg 
                            })
                          }
                        }
                      }
                    }

                    if(checking === true){
                      this.GetApplicationAvailableUnitCheck({
                        applicationId: this.StoreStateCD.FormDetails.ApplicationId 
                      }).then(res=>{
                        if(res === "1"){
                          if(this.StoreStateT.fundUnitConfirm.length>0){
                              for(var i=0; i<this.StoreStateT.fundUnitConfirm.length; i++){
                                msg = 'Insufficient Unit for ' + this.StoreStateT.fundUnitConfirm[i].SchemeName + ' ,Transaction Units : '+ this.StoreStateT.fundUnitConfirm[i].TransactionUnit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +' Units , Available Units : ' + this.StoreStateT.fundUnitConfirm[i].SchemeUnitAvailable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " Units"
                            
                                this.$q.loading.hide()
                                this.$q.dialog({
                                  title : 'Unable to proceed Switching.',
                                  message :  msg 
                                })
                              }
                          }else{

                            
                            this.eMISTransactionConfirmSwitchRedeem({
                              DigitalID : this.StoreStateCD.FormDetails.ApplicationId
                            }).then(res=>{
                              this.$store.dispatch('Logging',
                                {
                                    typeid :'5', 
                                    appid : '2',
                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirmSwitchRedeem(Switch), -> res -> ' + res
                                });

                              if(res===true){

                                this.StoreStateAD.OpenPopUp = true;
                                this.$q.loading.hide()
                                vm.StoreStateAD.SwitchingStep = '2';
                              }else{
                                this.$q.loading.hide()
                                this.$q.dialog({
                                  title : 'Message',
                                  message : 'Something went wrong. ' + res 
                                })
                              }
                            })  
                          }
                        }else{
                          this.$q.loading.hide()
                          this.$q.dialog({
                            title : 'Warning',
                            message :  res 
                          })
                        }
                      })
                    }                     
                  }else{  
                    this.$q.loading.hide()
                    this.$q.dialog({
                      title : 'Warning',
                      message :  res 
                    })
                  }                 
              })
        /*   }else{            
            this.$q.loading.hide()
            this.$q.dialog({
                title : 'Message',
                message : 'Something went wrong. ' + res 
            })
          }
        }) */
      }else{
        return false
      } 
    },
    toAccountVerification:function(){
           this.$store.dispatch('Logging',
        {
            typeid :'5', 
            appid : '2',
            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' RequestTAC (Switch), -> RequestTAC -> ' + this.StoreStateAOD.ContactInformation.MobileNo+' res:'+ res
        });
        
           // this.StoreStateAOD.ContactInformation.MobileNo  ='0149638728'
            this.formatMobileNo()
            this.RequestTAC({
              //'this.StoreStateAOD.ContactInformation.MobileNo'
                 CustomerTelMobile : this.StoreStateAOD.ContactInformation.MobileNo,
                Purpose : 'EMIS - Account Verification',
                CustomerId : this.StoreStateAOD.PersonalInformation.NRIC,
                RIDType : ''
            })
            .then(res=>{
                if(res===true){  
                    this.$q.dialog({
                        title : 'Message _2',
                        message : 'A TAC has been sent to your mobile no ' +   this.tempMobileNo
                    })
                }else{
                        this.$q.dialog({
                            title :  'Warning',
                            message :  res
                        })
                    }
            }) 
        }, formatMobileNo:function() {
          //this.StoreStateAOD.ContactInformation.MobileNo  ='0149638728'
          var mobileNo = this.StoreStateAOD.ContactInformation.MobileNo      

          this.tempMobileNo =  '01x- xxxx ' + mobileNo.slice(-4) ;
      },

    DoneBasisRecommendation(){
      if(this.StoreStateCD.SAT.ReferenceId===''){
        this.StoreStateCD.SAT.ReferenceId = uid();
      }
      this.PostSATDetails({ReferenceId:this.StoreStateCD.SAT.ReferenceId})
      .then(res=>{
        if(res==='error'){
          this.$q.dialog({
              title: 'Error',
              message: 'Something went wrong. Please contact your administrator.',
          })    
        }
        else{
          this.BasisRecommendationModal = false
          this.$router.push({name:'Payment'})
        }
      })
    },
    AddtoCart(){
      this.CreateTempId();
      this.CreateFundTransaction_Investment();
      this.PostTransaction({
          ApplicationId : this.StoreStateCD.FormDetails.ApplicationId
      })
      .then(res=>{
        if(res==='error'){
          this.$q.dialog({
              title: 'Error',
              message: 'Something went wrong. Please contact your administrator.',
          })    
        }
        else{
          this.BuyNewFundModal = false;
          this.ClearNewFundModal();
        }
      })
    },
    CreateFundTransaction_Investment(){
      this.StoreStateCD.Transaction.Investment.push({
        Id: this.TransactionId,
        Amount : this.$refs.refFTNF.Form.Amount,
        SalesCharge : this.$refs.refFTNF.Form.SalesCharge,
        SmartSave : this.$refs.refFTNF.Form.SmartSave,
        SmartSaveStartDate : date.formatDate(this.$refs.refFTNF.Form.SmartSaveStartDate, 'YYYY-MM-DD'),
        SmartSaveEndDate : date.formatDate(this.$refs.refFTNF.Form.SmartSaveEndDate, 'YYYY-MM-DD'),
        ModeOfFrequency : this.$refs.refFTNF.Form.ModeOfFrequency,
        DateOfDeduction : this.$refs.refFTNF.Form.DateOfDeduction,
        FundID : this.$refs.refFTNF.Form.FundCode.value,
        FundName : this.$refs.refFTNF.Form.FundCode.label,
        Plan : this.$refs.refFTNF.Form.Plan,
        FundCurrency : this.$refs.refFTNF.Form.Currency,
        TypeOfProduct : this.StoreStateCD.Account.AccountType,
        DistributionInstruction : this.$refs.refFTNF.Form.DistributionInstruction
      })
    },
    CreateTempId() {
      var dt = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (dt + Math.random()*16)%16 | 0;
          dt = Math.floor(dt/16);
          return (c=='x' ? r :(r&0x3|0x8)).toString(16);
      });
      this.TransactionId =  uuid;
    },
    BuyNewFund() {
     /* if(
        this.StoreStateCD.SAT.InvestmentObjective.value===''
        || this.StoreStateCD.SAT.InvestmentPeriod.value===''
        || this.StoreStateCD.SAT.EstimatedNetWorth.value===''
        || this.StoreStateCD.SAT.EstimatedLiability.value===''
        || this.StoreStateCD.SAT.AnnualisedGain.value===''
        || this.StoreStateCD.SAT.Age.value===''
        || this.StoreStateCD.SAT.AnnualIncome.value===''
        || this.StoreStateCD.SAT.RiskTolerance.value===''
        || this.StoreStateCD.SAT.Bonds===''
        || this.StoreStateCD.SAT.Derivatives===''
        || this.StoreStateCD.SAT.Equities===''
        || this.StoreStateCD.SAT.UTF===''
      ){
        this.$q.dialog({
            title: 'Message',
            message: 'Kindly complete Suitability Assessment.',
        })
        .onOk(() => {
            this.$router.push({name : 'sat'})
        })
      }
      else{}*/
        this.BuyNewFundModal = true;
        this.FilterFundPlanByProductType({ ProductType: this.StoreStateCD.Account.AccountType })
      
    },
    ClearNewFundModal(){
      this.$refs.refFTNF.Form.Id = ''
      this.$refs.refFTNF.Form.Plan = ''
      this.$refs.refFTNF.Form.FundName = ''
      this.$refs.refFTNF.Form.FundCode = ''
      this.$refs.refFTNF.Form.DisagreeRecommendation = false
      this.$refs.refFTNF.Form.Amount = 0
      this.$refs.refFTNF.Form.SalesCharge = 0
      this.$refs.refFTNF.Form.SmartSave = false
      this.$refs.refFTNF.Form.SmartSaveStartDate = ''
      this.$refs.refFTNF.Form.SmartSaveEndDate = ''
      this.$refs.refFTNF.Form.ModeOfFrequency = ''
      this.$refs.refFTNF.Form.DateOfDeduction = []
      this.$refs.refFTNF.Form.MinInvAmt = 0
      this.$refs.refFTNF.Form.Currency = 'MYR'
    },
    GoToSAT(){
      this.$router.push({name:"sat"})
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    showMsg() {
      var str = "";
      str += "<q-item>";
      str += "<q-item-main>";
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">1.	An individual whose total net personal assets, or total net joint assets with his or her spouse, exceed RM3 million or its equivalent in foreign currencies, excluding the value of the individual’s primary residence; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">2.	An individual who has a gross annual income exceeding RM300,000 or its equivalent in foreign currencies per annum in the preceding twelve months; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">3.	An individual who, jointly with his or her spouse, has a gross annual income exceeding RM400,000 or its equivalent in foreign currencies per annum in the preceding twelve months; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">4.	A corporation with total net assets exceeding RM10 million or its equivalent in foreign currencies based on the last audited accounts; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">5.	A partnership with total net assets exceeding RM10 million or its equivalent in foreign currencies; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">6.	A unit trust scheme or prescribed investment scheme; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">7.	A private retirement scheme; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">8.	A closed-end fund approved by the Securities Commission Malaysia; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">9.	A company that is registered as a trust company under the Trust Companies Act 1949 which has assets under management exceeding RM10 million or its equivalent in foreign currencies; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">10.	A corporation that is a public company under the Companies Act 1965 which is approved by the Securities Commission Malaysia to be a trustee under the Capital Markets and Services Act 2007 and has assets under management exceeding RM10 million or its equivalent in foreign currencies;</q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">11.	A statutory body established by an Act of Parliament or an enactment of any State; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">12.	A pension fund approved by the Director General of Inland Revenue under section 150 of the Income Tax Act 1967; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">13.	A holder of a capital markets services license or an executive director or a chief executive officer of a holder of a capital markets services license; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">14.	A licensed institution as defined in the Financial Services Act 2013; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">15.	An Islamic bank as defined in the Islamic Financial Services Act 2013; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">16.	An insurance company registered under the Financial Services Act 2013; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">17.	A takaful operator registered under the Islamic Financial Services Act 2013; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">18.	A bank licensee or insurance licensee as defined under the Labuan Financial Services and Securities Act 2010; </q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">19.	An Islamic bank licensee or takaful licensee as defined under the Labuan Islamic Financial Services and Securities Act 2010; and</q-item-tile><br>';
      str +=
        '<q-item-tile sublabel lines="20" style="color:black;">20.	Any other investor as may be defined by the Securities Commission Malaysia from time to time. </q-item-tile><br>';
      str += "</q-item-main>";
      str += "</q-item>";
      this.$q.dialog({
        title:
          "<q-list-header>Who can be referred as Sophisticated Investor?</q-list-header>",
        message: str,
        html: true
      });
    },
    scrollPositionToTop(){
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
  }
};
</script>